import { render, staticRenderFns } from "./apply-tag-detail-list-modal.vue?vue&type=template&id=0d01058a"
import script from "./apply-tag-detail-list-modal.vue?vue&type=script&lang=js"
export * from "./apply-tag-detail-list-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports